import React from 'react';
import { Phone, FileText, Download, ExternalLink, AlertCircle } from 'lucide-react';
export function RegistrationLicensingFormsPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-3574">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-3575">
        <div className="container mx-auto px-4" data-id="element-3576">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-3577">
            Registration & Licensing Forms
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-3578">
            FMCSA Required Forms & Applications
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-3579">
        <div className="max-w-5xl mx-auto" data-id="element-3580">
          {/* Online Submission Notice */}
          <div className="bg-blue-50 border-2 border-blue-500 rounded-lg shadow-md p-6 mb-8" data-id="element-3581">
            <div className="flex items-start" data-id="element-3582">
              <AlertCircle className="text-blue-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-3583" />
              <div data-id="element-3584">
                <p className="text-gray-800" data-id="element-3585">
                  The following are printable Registration and Licensing forms,
                  however,{' '}
                  <strong data-id="element-3586">
                    FMCSA strongly encourages users to{' '}
                    <a href="http://www.fmcsa.dot.gov/registration-licensing/online-registration/onlineregdescription.htm" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-bold" data-id="element-3587">
                      submit these forms online
                    </a>
                  </strong>
                  .
                </p>
              </div>
            </div>
          </div>

          {/* USDOT Number Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3588">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3589">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3590" />
              USDOT Number
            </h2>

            <div className="space-y-3" data-id="element-3591">
              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/MCS-150-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-blue-50 hover:bg-blue-100 border-2 border-blue-200 rounded-lg p-4 transition-colors group" data-id="element-3592">
                <div className="flex items-center flex-1" data-id="element-3593">
                  <div className="bg-blue-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3594">
                    MCS-150
                  </div>
                  <div className="flex-1" data-id="element-3595">
                    <p className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-3596">
                      Motor Carrier Identification Report
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3597">
                      Application for USDOT Number
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3598">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-blue-600 ml-4 flex-shrink-0" size={20} data-id="element-3599" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/MCS-150A-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-green-50 hover:bg-green-100 border-2 border-green-200 rounded-lg p-4 transition-colors group" data-id="element-3600">
                <div className="flex items-center flex-1" data-id="element-3601">
                  <div className="bg-green-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3602">
                    MCS-150A
                  </div>
                  <div className="flex-1" data-id="element-3603">
                    <p className="font-semibold text-gray-900 group-hover:text-green-600 transition-colors" data-id="element-3604">
                      Safety Certification for Application for USDOT Number
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3605">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-green-600 ml-4 flex-shrink-0" size={20} data-id="element-3606" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/MCS-150B-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-purple-50 hover:bg-purple-100 border-2 border-purple-200 rounded-lg p-4 transition-colors group" data-id="element-3607">
                <div className="flex items-center flex-1" data-id="element-3608">
                  <div className="bg-purple-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3609">
                    MCS-150B
                  </div>
                  <div className="flex-1" data-id="element-3610">
                    <p className="font-semibold text-gray-900 group-hover:text-purple-600 transition-colors" data-id="element-3611">
                      Combined Motor Carrier Identification Report and Hazardous
                      Materials Permit Application
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3612">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-purple-600 ml-4 flex-shrink-0" size={20} data-id="element-3613" />
              </a>
            </div>
          </div>

          {/* Operating Authority (MC Number) Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3614">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3615">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3616" />
              Operating Authority (MC Number)
            </h2>

            <div className="space-y-3" data-id="element-3617">
              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/op-1-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-blue-50 hover:bg-blue-100 border-2 border-blue-200 rounded-lg p-4 transition-colors group" data-id="element-3618">
                <div className="flex items-center flex-1" data-id="element-3619">
                  <div className="bg-blue-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3620">
                    OP-1
                  </div>
                  <div className="flex-1" data-id="element-3621">
                    <p className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-3622">
                      Application for Motor Property Carrier and Broker
                      Authority
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3623">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-blue-600 ml-4 flex-shrink-0" size={20} data-id="element-3624" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/OP-1(FF)-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-green-50 hover:bg-green-100 border-2 border-green-200 rounded-lg p-4 transition-colors group" data-id="element-3625">
                <div className="flex items-center flex-1" data-id="element-3626">
                  <div className="bg-green-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3627">
                    OP-1(FF)
                  </div>
                  <div className="flex-1" data-id="element-3628">
                    <p className="font-semibold text-gray-900 group-hover:text-green-600 transition-colors" data-id="element-3629">
                      Application for Freight Forwarder Authority
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3630">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-green-600 ml-4 flex-shrink-0" size={20} data-id="element-3631" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/forms/r-l/OP-1(P)-Instructions-and-Form.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-purple-50 hover:bg-purple-100 border-2 border-purple-200 rounded-lg p-4 transition-colors group" data-id="element-3632">
                <div className="flex items-center flex-1" data-id="element-3633">
                  <div className="bg-purple-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3634">
                    OP-1(P)
                  </div>
                  <div className="flex-1" data-id="element-3635">
                    <p className="font-semibold text-gray-900 group-hover:text-purple-600 transition-colors" data-id="element-3636">
                      Application for Motor Passenger Carrier Authority
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3637">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-purple-600 ml-4 flex-shrink-0" size={20} data-id="element-3638" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/op-1mx.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-orange-50 hover:bg-orange-100 border-2 border-orange-200 rounded-lg p-4 transition-colors group" data-id="element-3639">
                <div className="flex items-center flex-1" data-id="element-3640">
                  <div className="bg-orange-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3641">
                    OP-1(MX)
                  </div>
                  <div className="flex-1" data-id="element-3642">
                    <p className="font-semibold text-gray-900 group-hover:text-orange-600 transition-colors" data-id="element-3643">
                      Application to Register Mexico-based Carriers
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3644">
                      For Motor Carrier Authority to Operate Beyond U.S.
                      Municipalities and Commercial Zones on the U.S.-Mexico
                      Border
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3645">
                      <a href="http://www.fmcsa.dot.gov/documents/forms/op-1mx_instructions.pdf" className="text-orange-600 hover:underline" data-id="element-3646">
                        Instructions (PDF)
                      </a>{' '}
                      - Spanish instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-orange-600 ml-4 flex-shrink-0" size={20} data-id="element-3647" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/op-2.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-red-50 hover:bg-red-100 border-2 border-red-200 rounded-lg p-4 transition-colors group" data-id="element-3648">
                <div className="flex items-center flex-1" data-id="element-3649">
                  <div className="bg-red-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3650">
                    OP-2
                  </div>
                  <div className="flex-1" data-id="element-3651">
                    <p className="font-semibold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-3652">
                      Application for Mexican Certificate of Registration
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3653">
                      For Foreign Motor Carriers and Foreign Motor Private
                      Carriers Under 49 U.S.C. 13902
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3654">
                      <a href="http://www.fmcsa.dot.gov/documents/forms/OP-2_Instructions.pdf" className="text-red-600 hover:underline" data-id="element-3655">
                        Instructions (PDF)
                      </a>{' '}
                      - Spanish instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-red-600 ml-4 flex-shrink-0" size={20} data-id="element-3656" />
              </a>
            </div>
          </div>

          {/* Process Agent Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3657">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3658">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3659" />
              Process Agent
            </h2>

            <div className="space-y-3" data-id="element-3660">
              <a href="http://www.fmcsa.dot.gov/documents/boc.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-indigo-50 hover:bg-indigo-100 border-2 border-indigo-200 rounded-lg p-4 transition-colors group" data-id="element-3661">
                <div className="flex items-center flex-1" data-id="element-3662">
                  <div className="bg-indigo-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3663">
                    BOC-3
                  </div>
                  <div className="flex-1" data-id="element-3664">
                    <p className="font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors" data-id="element-3665">
                      Designation of Process Agents
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3666">
                      Motor Carriers, Brokers and Freight Forwarders
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3667">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-indigo-600 ml-4 flex-shrink-0" size={20} data-id="element-3668" />
              </a>
            </div>
          </div>

          {/* Other Forms */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3669">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3670">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3671" />
              Other
            </h2>

            <div className="space-y-3" data-id="element-3672">
              <a href="http://www.fmcsa.dot.gov/documents/bmc-85.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-teal-50 hover:bg-teal-100 border-2 border-teal-200 rounded-lg p-4 transition-colors group" data-id="element-3673">
                <div className="flex items-center flex-1" data-id="element-3674">
                  <div className="bg-teal-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3675">
                    BMC-85
                  </div>
                  <div className="flex-1" data-id="element-3676">
                    <p className="font-semibold text-gray-900 group-hover:text-teal-600 transition-colors" data-id="element-3677">
                      Property Broker's Trust Fund Agreement
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-3678">
                      Under 49 U.S.C. 13906 or Notice of Cancellation of the
                      Agreement
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3679">
                      No instructions
                    </p>
                  </div>
                </div>
                <Download className="text-teal-600 ml-4 flex-shrink-0" size={20} data-id="element-3680" />
              </a>

              <a href="http://www.fmcsa.dot.gov/documents/oce46.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between bg-gray-50 hover:bg-gray-100 border-2 border-gray-200 rounded-lg p-4 transition-colors group" data-id="element-3681">
                <div className="flex items-center flex-1" data-id="element-3682">
                  <div className="bg-gray-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-3683">
                    OCE-46
                  </div>
                  <div className="flex-1" data-id="element-3684">
                    <p className="font-semibold text-gray-900 group-hover:text-gray-600 transition-colors" data-id="element-3685">
                      Request for Revocation of Registration
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3686">
                      Instructions included in form
                    </p>
                  </div>
                </div>
                <Download className="text-gray-600 ml-4 flex-shrink-0" size={20} data-id="element-3687" />
              </a>
            </div>
          </div>

          {/* Commodity Regulation Information */}
          <div className="bg-yellow-50 border-2 border-yellow-500 rounded-lg shadow-md p-6 mb-8" data-id="element-3688">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-3689">
              Determining Regulated Commodities
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-3690">
              To determine if the company's commodities are regulated, refer to{' '}
              <a href="http://www.fmcsa.dot.gov/documents/adminrule.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-semibold inline-flex items-center" data-id="element-3691">
                Administration Ruling 119{' '}
                <ExternalLink className="ml-1" size={14} data-id="element-3692" />
              </a>
              .
            </p>
            <p className="text-gray-700" data-id="element-3693">
              <strong data-id="element-3694">
                If any commodity the company is transporting does not appear on
                these lists as exempt, then it is regulated.
              </strong>
            </p>
          </div>

          {/* Quick Reference Summary */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3695">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3696">Forms Quick Reference</h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-3697">
              <div data-id="element-3698">
                <h3 className="text-xl font-bold mb-3" data-id="element-3699">
                  USDOT Number (3 forms)
                </h3>
                <ul className="space-y-1 text-sm" data-id="element-3700">
                  <li data-id="element-3701">• MCS-150: Motor Carrier ID Report</li>
                  <li data-id="element-3702">• MCS-150A: Safety Certification</li>
                  <li data-id="element-3703">• MCS-150B: Combined Report + Hazmat</li>
                </ul>
              </div>

              <div data-id="element-3704">
                <h3 className="text-xl font-bold mb-3" data-id="element-3705">
                  Operating Authority (5 forms)
                </h3>
                <ul className="space-y-1 text-sm" data-id="element-3706">
                  <li data-id="element-3707">• OP-1: Property Carrier & Broker</li>
                  <li data-id="element-3708">• OP-1(FF): Freight Forwarder</li>
                  <li data-id="element-3709">• OP-1(P): Passenger Carrier</li>
                  <li data-id="element-3710">• OP-1(MX): Mexico-based Carriers</li>
                  <li data-id="element-3711">• OP-2: Mexican Certificate</li>
                </ul>
              </div>

              <div data-id="element-3712">
                <h3 className="text-xl font-bold mb-3" data-id="element-3713">
                  Process Agent (1 form)
                </h3>
                <ul className="space-y-1 text-sm" data-id="element-3714">
                  <li data-id="element-3715">• BOC-3: Designation of Process Agents</li>
                </ul>
              </div>

              <div data-id="element-3716">
                <h3 className="text-xl font-bold mb-3" data-id="element-3717">Other (2 forms)</h3>
                <ul className="space-y-1 text-sm" data-id="element-3718">
                  <li data-id="element-3719">• BMC-85: Broker's Trust Fund Agreement</li>
                  <li data-id="element-3720">• OCE-46: Revocation Request</li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-3721">
            <h2 className="text-3xl font-bold mb-4" data-id="element-3722">
              Need Help with Registration & Licensing?
            </h2>
            <p className="text-xl mb-6" data-id="element-3723">
              Expert guidance on FMCSA forms and compliance requirements
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-3724">
              <Phone className="mr-3" size={24} data-id="element-3725" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-3726">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}